<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isBuyer()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Lot Details</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
<section class="content">
<div class="row">
	
	<br>	<!-- main row for all icons  -->
	<div class="col-sm-3">
		<div class="card card-primary card-outline">
			<div class="card-body">

				<table class="table table-striped table-hover">
				<tbody>
  <tr>
    <td><b>Lot Name: </b></td>
    <td>{{lotDetails.name}}</td>
  </tr>
  <tr>
    <td><b>Description: </b></td>
    <td>{{lotDetails.description}}</td>
  </tr>
   <tr>
    <td><b>Lot Type: </b></td>
    <td><b>{{lotDetails.type}}</b></td>
  </tr>
   <tr>
    <td><b>Lot Sub-Type: </b></td>
    <td><b>{{lotDetails.subtype}}</b></td>
  </tr>
  <tr>
    <td><b>Liter Weight: </b></td>
    <td>{{lotDetails.liter_weight}}</td>
  </tr>
  <tr>
    <td><b>Net Weight: </b></td>
    <td>{{lotDetails.net_weight}}</td>
  </tr>
  <tr>
    <td><b>Sample Weight: </b></td>
    <td>{{lotDetails.sample_weight}}</td>
  </tr>
  <tr>
    <td><b>Color: </b></td>
    <td>{{lotDetails.color}}</td>
  </tr>
  <tr>
    <td><b>Moisture Content: </b></td>
    <td>{{lotDetails.moisture_content}}</td>
  </tr>
  <tr>
    <td><b>Clean Lot: </b></td>
    <td v-if="lotDetails.clean_lot == 1">Yes</td>
    <td v-else>No</td>
  </tr>
  <tr>
    <td><b>Quote Price: </b></td>
    <td>{{lotDetails.quote_price}}</td>
  </tr>
  <tr>
    <td><b>Discount: </b></td>
    <td>{{lotDetails.discount}}</td>
  </tr>
  <tr>
    <td><b>Seller: </b></td>
    <td>{{lotDetails.seller}}</td>
  </tr>
  </tbody>
</table>	
			</div>
		</div>
	</div>

	<div class="col-sm-9">
		<div class="card card-primary card-outline">
			<div class="card-body overflow-auto">
				<div class="col-sm-12">
				<datatable style="margin-top:1%; margin-left:1%; margin-right:1%; margin-bottom:1%;" :columns="pcolumns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy">
      	<tbody>
        	<tr>
          		<td>{{row[0].row_name}}</td>
				<td>
					{{r1c1p}}
				</td>
				<td>
					{{r1c2p}}
				</td>
				<td>
					{{r1c3p}}
				</td>
				<td v-if="lotDetails.subtype != 'Seed' && lotDetails.subtype != 'Pan'">
					{{r1c4p}}
				</td>
				<td>
					<b>{{totalr1p}}</b>
				</td>
          	</tr>
			  <tr v-if="lotDetails.subtype != 'Seed' && lotDetails.subtype != 'Pan'">
          		<td>{{row[1].row_name}}</td>
				<td>
					{{r2c1p}}
				</td>
				<td>
					{{r2c2p}}
				</td>
				<td>
					{{r2c3p}}
				</td>
				<td>
					{{r2c4p}}
				</td>
				<td>
					<b>{{totalr2p}}</b>
				</td>
          	</tr>
			  <tr v-if="lotDetails.subtype != 'Seed' && lotDetails.subtype != 'Pan'">
          		<td>{{row[2].row_name}}</td>
				<td>
					{{r3c1p}}
				<td>
					{{r3c2p}}
				</td>
				<td>
					{{r3c3p}}
				</td>
				<td>
					{{r3c4p}}
				</td>
				<td>
					<b>{{totalr3p}}</b>
				</td>
          	</tr>	
			  <tr>
          		<th>Total %</th>
				<td>
					<b>{{totalc1p}}</b>
				</td>
				<td>
					<b>{{totalc2p}}</b>
				</td>
				<td>
					<b>{{totalc3p}}</b>
				</td>
				<td v-if="lotDetails.subtype != 'Seed' && lotDetails.subtype != 'Pan'">
					<b>{{totalc4p}}</b>
				</td>
				<td>
					<b>{{totalp}}</b>
				</td>
          	</tr>			
        </tbody>
      </datatable>
     	</div>
      <div class="col-sm-12">
		<div class="card card-primary card-outline">
			<div class="card-body">
<!-- Image Here -->
				<img :src="lotDetails.image_url" alt="Lot Image" style="max-width: 100%;">
			</div>
		</div>
	</div>
    </div>		
		</div>
		</div>
		



	</div>
	<!-- row end -->
</section>
<br>
      <br>
    <!-- /.content -->
</div>
		
	
    
<!-- All VUE Parts end before this comment -->
        
        <div v-if="!$gate.isBuyer()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		import Datatable from '../datatable.vue';
    import Pagination from '../pagination.vue';
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        components: {datatable:Datatable, pagination:Pagination},
        
        created(){
        	this.getLotDetails();
        	//this.getQualities();
        	this.getGrades();
        	this.getLotGrades();
        },
        
        data(){
        	let sortOrders = {};
      		let columns = [
				  {width:'10%', label:"Grade/Quality", name:'value_mg'},

      		];
      		//columns.forEach((column) => {
          	//sortOrders[column.name]=-1;
        	//});
        		
        	return {
        		columns: [
				  {width:'10%', label:"Grade/Quality", name:'value_mg'},

				  ],
				  
				  	pcolumns: [],
        		sortKey: 'id',
        		sortOrders: sortOrders,
        		tableData: {
        			draw: 0,
        			length: 10,
        			column: 0,
        			dir: 'desc'
        		},
        		pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
        		form: new Form({
        			value_mg: '',
        			value_percentage: '',
        			created_by: this.$userId,
        			updated_by: this.$userId,
        			lot_id: '',
        			grade_id: '',
        			quality_id: '',
        			id: ''
        		}),
        		
        		lotDetails: [],
        		qualities: [],
        		grades: [],
        		lotGrades: [],
        		errors: [],
				row: [],
				values : [],
				r1c1p: '',
				r1c2p: '',
				r1c3p: '',
				r1c4p: '',
				r2c1p: '',
				r2c2p: '',
				r2c3p: '',
				r2c4p: '',
				r3c1p: '',
				r3c2p: '',
				r3c3p: '',
				r3c4p: '',
				totalc1p: '',
				totalc2p: '',
				totalc3p: '',
				totalc4p: '',
				totalr1p: '',
				totalr2p: '',
				totalr3p: '',
				totalp: ''
			}
		},
        methods: {
        	configPagination(data){
      		this.pagination.last_page=data.last_page;
         	this.pagination.currentPage=data.current_page;
    	  	this.pagination.total=data.total;
        	this.pagination.lastPageUrl=data.last_page_url;
       		this.pagination.nextPageUrl=data.next_page_url;
       		this.pagination.prevPageUrl=data.prev_page_url;
     		 	this.pagination.from=data.from;
        	this.pagination.to=data.to;
    		},
  
      	sortBy(key){
     			this.sortKey=key;
      		this.sortOrders[key] = this.sortOrders[key]*-1;
       	  this.tableData.column = this.getIndex(this.columns, 'name', key);
 	     	  this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
    		},
     		
     		getIndex(array, key, value){
       		return array.findIndex(i => i[key] == value)
       	},
        	getGrades(url="/api/getGrades"){
       			axios.post(url)
       			.then(response => {
       				this.grades = response.data;
       				//this.configPagination(response.data.data);
       			})
       		},
       		
       		getQualities(url="/api/getQualities"){
       			axios.post(url, {subtype: this.lotDetails.subtype})
       			.then(response => {
       				this.qualities = response.data;
					   //this.configPagination(response.data.data);
					for(var i=0; i<this.qualities.length;i++){
						this.columns.push(
							{width: '10%', label: this.qualities[i].name, name: this.qualities[i].name}
						);
					}
					this.pcolumns = this.columns;
					this.columns.push(
							{width: '10%', label: "Total %", name: "total"}
						);
       			})
       		},
       		
       		getLotDetails(){
       			axios.post("/api/getLotDetails", {id: this.$route.params.id, customer: true})
       			.then(response => {
       				this.lotDetails = response.data;
       				this.getTemplate();
       				this.getQualities();
       			})
       		},
       		
       		getLotGrades(){
       			this.form.lot_id = this.$route.params.id;
       			axios.post("/api/getLotGrades", {id: this.$route.params.id})
       			.then(response => {
						this.r1c1p = parseFloat(response.data[0].value_percentage).toPrecision(3);
						this.r1c2p = parseFloat(response.data[1].value_percentage).toPrecision(3);
						this.r1c3p = parseFloat(response.data[2].value_percentage).toPrecision(3);
						if(this.lotDetails.subtype != 'Seed' && this.lotDetails.subtype != 'Pan'){
							this.r1c4p = parseFloat(response.data[3].value_percentage).toPrecision(3);
							this.r2c1p = parseFloat(response.data[4].value_percentage).toPrecision(3);
							this.r2c2p = parseFloat(response.data[5].value_percentage).toPrecision(3);
							this.r2c3p = parseFloat(response.data[6].value_percentage).toPrecision(3);
							this.r2c4p = parseFloat(response.data[7].value_percentage).toPrecision(3);
							this.r3c1p = parseFloat(response.data[8].value_percentage).toPrecision(3);
							this.r3c2p = parseFloat(response.data[9].value_percentage).toPrecision(3);
							this.r3c3p = parseFloat(response.data[10].value_percentage).toPrecision(3);
							this.r3c4p = parseFloat(response.data[11].value_percentage).toPrecision(3);   
							this.calculatePercentage();
						}
						else{
							this.calculateSeed();
						} 
       			})
       		}, 
       		
       		calculatePercentage(){
				   	this.totalc1p = (parseFloat(this.r1c1p)+parseFloat(this.r2c1p)+parseFloat(this.r3c1p)).toPrecision(4);
						this.totalc2p = (parseFloat(this.r1c2p)+parseFloat(this.r2c2p)+parseFloat(this.r3c2p)).toPrecision(4);
						this.totalc3p = (parseFloat(this.r1c3p)+parseFloat(this.r2c3p)+parseFloat(this.r3c3p)).toPrecision(4);
						this.totalc4p = (parseFloat(this.r1c4p)+parseFloat(this.r2c4p)+parseFloat(this.r3c4p)).toPrecision(4);
						this.totalr1p = (parseFloat(this.r1c1p)+parseFloat(this.r1c2p)+parseFloat(this.r1c3p)+parseFloat(this.r1c4p)).toPrecision(4);
						this.totalr2p = (parseFloat(this.r2c1p)+parseFloat(this.r2c2p)+parseFloat(this.r2c3p)+parseFloat(this.r2c4p)).toPrecision(4);
						this.totalr3p = (parseFloat(this.r3c1p)+parseFloat(this.r3c2p)+parseFloat(this.r3c3p)+parseFloat(this.r3c4p)).toPrecision(4);
						this.totalp = (parseFloat(this.totalc1p)+parseFloat(this.totalc2p)+parseFloat(this.totalc3p)+parseFloat(this.totalc4p)).toPrecision(3);
       		},
       		
       		calculateSeed(){
       			this.totalc1p = (parseFloat(this.r1c1p)).toPrecision(4);
						this.totalc2p = (parseFloat(this.r1c2p)).toPrecision(4);
						this.totalc3p = (parseFloat(this.r1c3p)).toPrecision(4);
						this.totalr1p = (parseFloat(this.r1c1p)+parseFloat(this.r1c2p)+parseFloat(this.r1c3p)).toPrecision(4);
						this.totalp = (parseFloat(this.totalc1p)+parseFloat(this.totalc2p)+parseFloat(this.totalc3p)).toPrecision(3);
       		},
       		
       		getTemplate(){
       			axios.post("/api/getTemplates", {type: this.lotDetails.subtype})
        		.then(response => {
					this.row = response.data;
        		})
			}
			}   
        }
</script>
